





















import { ButtonType } from '@getaccept/lib-ui';
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  setup() {
    return { ButtonType };
  },
});
